export default __webpack_public_path__ + "static/media/ug.6d5ab5bc.svg";